import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20skincare%20concept%20with%20natural%20botanical%20elements%20and%20clean%20glass%20bottles%20on%20a%20warm%20cream%20background%2C%20featuring%20soft%20textures%20and%20gentle%20lighting%2C%20abstract%20artistic%20composition%20with%20organic%20shapes%20and%20subtle%20golden%20highlights%2C%20serene%20and%20elegant%20atmosphere%2C%20editorial%20beauty%20photography&width=1600&height=800&seq=hero-skincare-2026&orientation=landscape"
        alt="全裸护肤 - 极简养肤理念"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full text-center px-6 md:px-10 max-w-4xl mx-auto">
        <span className="inline-block text-xs md:text-sm tracking-widest uppercase text-white/80 mb-4 px-4 py-1.5 border border-white/30 rounded-full whitespace-nowrap">
          全裸护肤理念
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-semibold text-white mb-5 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          回归本真，唤醒肌肤自愈力
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          抛弃层层叠叠的遮盖，用极简成分唤醒自然光泽。<br className="hidden md:block" />
          科学验证的裸肌养护之道，让每一寸肌肤自由呼吸。
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/jijian-hufu"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索极简护肤
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}